import { useState } from "react";
import { PublishedRecordBtn } from "../../../../utils/constants";
import ButtonGroup from "../../../common/ButtonGroup";
import Frequent from "./Frequent";
import PublishNew from "./PublishNew";
import Records from "./Records";

const PublishedRecord = ({ DID, date }) => {
  const [selected, setSelected] = useState("records");

  const handleButtonClick = (value) => {
    setSelected(value);
  };
  return (
    <div className="">
      <div className="py-4">
        <ul className="flex items-center gap-2 overflow-x-auto">
          <ButtonGroup
            buttons={PublishedRecordBtn}
            boxClass="min-w-[120px] lg:min-w-[250px]"
            onButtonClick={handleButtonClick}
            selected={selected}
          />
        </ul>
      </div>
      <div className="bg-gray-100 py-3 px-5 rounded-[12px] mb-4">
        {selected === "records" && <Records DocID={DID} />}
        {selected === "publishNew" && <PublishNew DocID={DID} date={date} />}
        {selected === "frequent" && <Frequent />}
      </div>
    </div>
  );
};
export default PublishedRecord;
